import { render, staticRenderFns } from "./TalkThreadChatForm.vue?vue&type=template&id=ed10b816&"
import script from "./TalkThreadChatForm.vue?vue&type=script&lang=ts&"
export * from "./TalkThreadChatForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports